<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.gerenciamentoEnvio"
            ref="RkmDataTable"
            sort-by="dataProtocolo"
            sort-desc
        >
            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    small
                    title="Registros enviados"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>

                <rkm-button
                    :disabled="row.item.processamentoStatusId !== enums.processamentoStatus.PROCESSAMENTO_FINALIZADO_COM_INCONSISTENCIA && row.item.processamentoStatusId !== enums.processamentoStatus.ERRO_INTERNO_SERVIDOR"
                    @click="$refs.ModalErro.open(row.item)"
                    color="danger"
                    small
                    title="Inconsistências"
                >
                    <rkm-icon icon="exclamation" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal ref="Modal" />
        <ModalErro ref="ModalErro" />
    </div>
</template>

<script>
// Components.
import Modal from './components/movimentacao/Modal'
import ModalErro from './components/erro/Modal'

// Enums.
import processamentoStatus from '@/enums/integracao/bnafar/processamentoStatus'

// Mixins.
import {repository, error} from '@/mixins'

export default {
    components: {Modal, ModalErro},
    created() {
        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.bnafar.gerenciamentoEnvio')
        }
    },
    computed: {
        fields() {
            return [
                {key: 'servicoTipoDescricao', label: 'Tipo de serviço', name: 'integracao_bnafar_servico_tipo.descricao', searchable: true, sortable: true},
                {key: 'operacaoTipoDescricao', label: 'Tipo de operação', name: 'integracao_bnafar_operacao_tipo.descricao', searchable: true, sortable: true},
                {key: 'processamentoStatusDescricao', label: 'Status do processamento', name: 'integracao_bnafar_processamento_status.descricao', searchable: true, sortable: true},
                {key: 'protocolo', label: 'Protocolo', name: 'integracao_bnafar_protocolo.protocolo', searchable: true, sortable: true},
                {key: 'dataProtocolo', label: 'Data do protocolo', name: 'integracao_bnafar_protocolo.data_protocolo', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    data: () => ({
        enums: {processamentoStatus},
    }),
    mixins: [repository, error]
}
</script>